import React from 'react';
import moment from 'moment';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import { Route, NavLink } from 'react-router-dom';

import MusicLibrary from 'common/components/music-library';

import ArtistInfoHeader from './fan-info-header';
import EditArtistForm from './edit-fan-form';

@inject('artistStore', 'userStore', 'songsStore', 'genreStore')
@observer
class EditFan extends React.Component {
	constructor (props) {
		super(props);

		const { _id } = this.props.artistStore.data.artist.toPOJO();
		this.props.songsStore.fetchSongsByArtist(_id);
	}

	render () {
		const { artistStore, userStore, songsStore, genreStore } = this.props;
		// const { userID, _id } = artistStore.data.artist.toPOJO();
		// const { totalScore, tier } = artistStore;
		const { createdAt } = userStore.getItemByID({ _id: _id });
		const joinedDate = moment(createdAt).format('MM/DD/YY');

		if (genreStore.isLoading) {

			return null;
		}

		return (
			<div className="artist-info-comp" onClick={ this.onClick }>
				<div className="grid-x">
					<div className="cell">
						<UserInfoHeader />
					</div>

					<div className="cell">
						<ul className="horizontal menu">
							<li><NavLink to={ `/user/info/${_id}` }>Fan Info</NavLink></li>
							{/* <li><NavLink to={ `/artist/library/${_id}` }>Artist Library</NavLink></li> */}
						</ul>
					</div>

					<div className="cell padding-1">
						<Route path="/user/info/:_id" exact render={ () => <EditArtistForm /> } />
						{/* <Route path="/artist/library/:_id" exact render={ () => <MusicLibrary /> } /> */}
					</div>
				</div>
			</div>
		);
	}

	@autobind
	onClick ({ target: { classList } }) {
		if (classList.contains('button') || classList.contains('delete-button-container')) {

			return;
		}

		const { songsStore } = this.props;
		songsStore.activeSongRowID = null;
	}
}

export default EditFan;
